import axiosClient from "../../../shared/lib/axiosClient";
import { USER_API_BASE } from "../../../shared/utils/apiConfig";

type Id = number | string;

// Result of a code run. Intermediate statuses (waiting / active / delayed) mean "check again".
export interface CodeJob {
    status: string;
    stdout?: string;
    stderr?: string;
    message?: string;
    [key: string]: unknown;
}

// Step 1: queue the program and get back the job id
export const enqueueCodeJob = async (
    userId: Id,
    payload: { code: string; language: string; stdin: string },
    signal?: AbortSignal
): Promise<string> => {
    const { data } = await axiosClient.post<{ jobId: string }>(
        `${USER_API_BASE}/${userId}/project`,
        payload,
        { signal }
    );
    return data.jobId;
};

// Step 2: ask how the job is doing
export const getCodeJob = async (
    userId: Id,
    jobId: string,
    signal?: AbortSignal
): Promise<CodeJob> => {
    const { data } = await axiosClient.get<CodeJob>(
        `${USER_API_BASE}/${userId}/project/${jobId}`,
        { signal }
    );
    return data;
};